





























































































































import { Component, Prop, Vue} from 'vue-property-decorator'
import AvatarOne from '@/components/icons/avatars/AvatarOne.vue'
import AvatarSelect from '@/components/virtual-colleague/AvatarSelect.vue'
import AvatarBanner from '@/components/virtual-colleague/AvatarBanner.vue'
import { CompanyAPI } from '@/api/backend-client'
import LoaderBalls from '@/components/LoaderBalls.vue'
import InputText from '@/components/input/InputText.vue'
import KvButton from '@/components/input/KvButton.vue'
import VirtualColleagueNavigation from '@/components/virtual-colleague/VirtualColleagueNavigation.vue'
import InputSwitch from '@/components/input/InputSwitch.vue'
import Tooltip from '@/components/ui/Tooltip.vue'
import { Company } from '@/api/model/company'

@Component({
    components: {
        AvatarBanner,
        AvatarOne,
        AvatarSelect,
        InputSwitch,
        InputText,
        KvButton,
        LoaderBalls,
        Tooltip,
        VirtualColleagueNavigation,
    },
})
export default class General extends Vue {
    loading: boolean = false
    submitting: boolean = false
    showEnableAiModal: boolean = false
    company: Company = null

    async mounted(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        try {
            this.loading = true
            await CompanyAPI.getCurrentCompany()
            this.company = this.$currentCompany
        } finally {
            this.loading = false
        }
    }

    async save() {
        try {
            this.loading = true
            this.submitting = true
            await CompanyAPI.update(this.company.id, this.company)
        } finally {
            await this.reload()
            this.loading = false
            this.submitting = false
        }
    }

    async saveWithAi() {
        this.company.virtualColleagueAiEnabled = true
        this.showEnableAiModal = false
        await this.save()

        // toOne is as a string because bool is not supported by type
        await this.$router.push({
            name: 'one_settings_virtual_colleague_ai',
            params: {
                toOne: 'true',
            },
        })
    }
}
